import { memo } from 'react'
import cn from 'classnames'

import {
  SKELETON_DEFAULT_HEIGHT,
  SKELETON_DEFAULT_RADIUS,
  SKELETON_LAST_LINE_WIDTH,
} from './config'
import type { SkeletonProps } from './types'

import styles from './Skeleton.module.scss'

/**
 * Заглушка загрузки по форме контента (правило 14) — шиммер, не спиннер.
 *
 * Временно (основатель): на многих экранах формы скелетонов не совпадают с реальной
 * вёрсткой и выглядят «ломано». Пока это не поправлено на конкретных экранах,
 * используйте `Loader` вместо `Skeleton` в новых и проблемных местах — сам компонент
 * не меняли, чтобы не сломать экраны, которые уже используют его аккуратно.
 */
export const Skeleton = memo(function Skeleton(props: SkeletonProps) {
  const {
    shape = 'RECT',
    width = '100%',
    height = SKELETON_DEFAULT_HEIGHT,
    lines = 1,
    radius,
  } = props

  const resolvedRadius = radius ?? SKELETON_DEFAULT_RADIUS[shape]

  if (shape === 'TEXT' && lines > 1) {
    return (
      <div className={styles.stack}>
        {Array.from({ length: lines }, (_, index) => {
          const isLast = index === lines - 1

          return (
            <div
              key={index}
              className={styles.root}
              style={{
                width: isLast ? SKELETON_LAST_LINE_WIDTH : width,
                height,
                borderRadius: resolvedRadius,
              }}
            />
          )
        })}
      </div>
    )
  }

  return (
    <div
      className={cn(styles.root, shape === 'CIRCLE' && styles.circle)}
      style={{ width, height, borderRadius: shape === 'CIRCLE' ? undefined : resolvedRadius }}
    />
  )
})
